<div class="py-1"></div>
<div class="card">
  <h6 class="card-header" style="cursor: pointer" (click)="showNewNewsletterMailinglistForm = !showNewNewsletterMailinglistForm"><i class="fas" [ngClass]="{ 'fa-plus-circle': !showNewNewsletterMailinglistForm, 'fa-minus-circle': showNewNewsletterMailinglistForm }"></i>&nbsp;Add to Mailing List</h6>
  <div class="card-body" [hidden]="!showNewNewsletterMailinglistForm" style="max-height: 340px; overflow-y: scroll">
    <div class="form-group">
      <label>Newsletter Mailing List</label>
      <select class="form-control form-control-sm" name="newNewsletterMailginlistId" ngDefaultControl [(ngModel)]="newNewsletterMailginlistId">
        <option *ngFor="let newsletterMailinglist of formOptions.newsletter_mailinglists" [value]="newsletterMailinglist.id">
          {{ newsletterMailinglist.name }}
        </option>
      </select>
    </div>
    <div class="form-row">
      <div class="col-6">
        <button type="button" class="btn btn-sm btn-primary btn-block" (click)="addToNewsletterMailinglist()">Add</button>
      </div>
      <div class="col-6">
        <button type="button" class="btn btn-sm btn-secondary btn-block" (click)="showNewNewsletterMailinglistForm = false">Cancel</button>
      </div>
    </div>
  </div>
</div>
<div class="py-1"></div>
<div class="float-right">
  <button type="button" [disabled]="loadingNewsletterMailinglists" (click)="loadNewsletterMailinglists()" class="btn btn-outline-primary btn-sm">
    <i class="fas fa-redo fa-fw" [ngClass]="{ 'fa-spin': loadingNewsletterMailinglists }"></i>
  </button>
</div>
<div class="clearfix"></div>
<div class="py-1"></div>
<table class="table table-sm">
  <tbody>
    <tr *ngFor="let newsletterMailinglist of newsletterMailinglists; let i = index">
      <td>
        <a [href]="'/newsletter_mailinglists/' + newsletterMailinglist.id">
          {{ newsletterMailinglist.name }}
        </a>
      </td>
      <td>
        <a class="pull-right float-right text-danger" href="javascript: void(0)" (click)="removeFromNewsletterMailinglist(newsletterMailinglist.id, newsletterMailinglist.name, i)"><i class="fas fa-trash"></i></a>
      </td>
    </tr>
  </tbody>
</table>
